
























import { Vue, Component, Prop } from "vue-property-decorator";
import { getBaseAllowedExts, validateFilesExt } from "@common/fileInputHelper";
import RoundCrossButton from "@share/common/buttons/RoundCrossButton.vue";

import VideoPlaceholder from "./VideoPlaceholder.vue";

@Component({
    components: { VideoPlaceholder, RoundCrossButton }
})
export default class FileUploadPlaceholder extends Vue {
    @Prop({ default: '' }) modificationName: string;
    @Prop({ default: 'image/*' }) acceptTypes: string;
    @Prop({ default: '' }) youtubeLink: string;
    @Prop({
        default: getBaseAllowedExts,
        required: false
    }) extensions: string[];

    onPlaceholderClick() {
        const fileInput = this.$refs['fileInput'] as HTMLInputElement;
        fileInput.value = '';
        fileInput.click();
    }

    onFileSelected(filesRaw: File[]) {

        if(!filesRaw) {
            return;
        }

        const files = Array.from(filesRaw);
        const validatedFiles = validateFilesExt(files, this.extensions);

        if(validatedFiles.invalid.length) {
            this.$emit('extInvalid', validatedFiles.extensions[0]);
        }
        else if (files && files[0]) {
            this.$emit('fileSelected', files[0]);
        }
    }

    remove(event: any) {
        event.stopPropagation()
        this.$emit('fileSelected', null);
    }

    onClick(event: MouseEvent) {
        event.stopPropagation();
    }
}
